
export const TRACKING = {
    TECH_CHECK: "TECH_CHECK",
    HOW_TO_USE_DATA: "HOW_TO_USE_DATA",
    HOW_TO_SCORE: "HOW_TO_SCORE",
    RESOURCES_DOWNLOAD: "RESOURCES_DOWNLOAD",
    VIDEO_PLAY: "VIDEO_PLAY",
    STUDENT_LOGIN: "STUDENT_LOGIN",
    TEACHER_LOGIN: "TEACHER_LOGIN",
    TEACHER_STUDENT_DETAILS_VIEW: "TEACHER_STUDENT_DETAILS_VIEW",
    TEACHER_STUDENT_DETAILS_SAVE_CHANGES: "TEACHER_STUDENT_DETAILS_SAVE_CHANGES",
    TEACHER_STUDENT_DETAILS_CHANGE_TEACHER_CLICK: "TEACHER_STUDENT_DETAILS_CHANGE_TEACHER_CLICK",
    TEACHER_SELECT_CLASS: "TEACHER_SELECT_CLASS",
    TEACHER_ADDED_CLASS: "TEACHER_ADDED_CLASS",
    TEACHER_UPDATED_CLASS: "TEACHER_UPDATED_CLASS",
    TEACHER_DELETED_CLASS: "TEACHER_DELETED_CLASS",
    TEACHER_STUDENT_DELETE: "TEACHER_STUDENT_DELETE",
    TEACHER_ADD_STUDENT: "TEACHER_ADD_STUDENT",
    STUDENT_PN_START: "STUDENT_PN_START",
    STUDENT_WSS_START: "STUDENT_WSS_START",
    STUDENT_CR_START: "STUDENT_CR_START",
    STUDENT_SLASH_START: "STUDENT_SLASH_START",
    STUDENT_KS_START: "STUDENT_KS_START",
    STUDENT_MAZE_START: "STUDENT_MAZE_START",
    STUDENT_KSS_START: "STUDENT_KSS_START",
    STUDENT_WM_START: "STUDENT_WM_START",
    CR_SCORE_VIEW: "CR_SCORE_VIEW",
    PN_SCORE_VIEW: "PN_SCORE_VIEW",
    WSS_SCORE_VIEW: "WSS_SCORE_VIEW",
    KS_SCORE_VIEW: "KS_SCORE_VIEW",
    KSS_SCORE_VIEW: "KSS_SCORE_VIEW",
    WM_SCORE_VIEW: "WM_SCORE_VIEW",
    PN_SCORE_SAVE: "PN_SCORE_SAVE",
    PN_SCORE_PLAY: "PN_SCORE_PLAY",
    PN_SCORE_EXIT: "PN_SCORE_EXIT",
    PN_SCORE_DELETE: "PN_SCORE_DELETE",
    WSS_SCORE_PLAY: "WSS_SCORE_PLAY",
    WSS_SCORE_SAVE: "WSS_SCORE_SAVE",
    WSS_SCORE_EXIT: "WSS_SCORE_EXIT",
    WSS_SCORE_DELETE: "WSS_SCORE_DELETE",
    CR_SCORE_PLAY: "CR_SCORE_PLAY",
    CR_SCORE_EXIT: "CR_SCORE_EXIT",
    CR_SCORE_DELETE: "CR_SCORE_DELETE",
    CR_SCORE_SAVE: "CR_SCORE_SAVE",
    KS_SCORE_PLAY: "KS_SCORE_PLAY",
    KS_SCORE_SAVE: "KS_SCORE_SAVE",
    KS_SCORE_DELETE: "KS_SCORE_DELETE",
    KS_SCORE_EXIT: "KS_SCORE_EXIT",
    KSS_SCORE_PLAY: "KSS_SCORE_PLAY",
    KSS_SCORE_SAVE: "KSS_SCORE_SAVE",
    KSS_SCORE_EXIT: "KSS_SCORE_EXIT",
    KSS_SCORE_DELETE: "KSS_SCORE_DELETE",
    WM_SCORE_EXIT: "WM_SCORE_EXIT",
    WM_SCORE_SAVE: "WM_SCORE_SAVE",
    WM_SCORE_DELETE: "WM_SCORE_DELETE",
    MAZE_DATACHART_VIEW: "MAZE_DATACHART_VIEW",
    KSS_DATACHART_VIEW: "KSS_DATACHART_VIEW",
    KS_DATACHART_VIEW: "KS_DATACHART_VIEW",
    WM_DATACHART_VIEW: "WM_DATACHART_VIEW",
    WSS_DATACHART_VIEW: "WSS_DATACHART_VIEW",
    SLASH_DATACHART_VIEW: "SLASH_DATACHART_VIEW",
    CR_DATACHART_VIEW: "CR_DATACHART_VIEW",
    PN_DATACHART_VIEW: "PN_DATACHART_VIEW",
    MAZE_DATACHART_VIEW_MICRO: "MAZE_DATACHART_VIEW_MICRO",
    KSS_DATACHART_VIEW_MICRO: "KSS_DATACHART_VIEW_MICRO",
    KS_DATACHART_VIEW_MICRO: "KS_DATACHART_VIEW_MICRO",
    MAZE_DATACHART_VIEW_MACRO: "MAZE_DATACHART_VIEW_MACRO",
    KSS_DATACHART_VIEW_MACRO: "KSS_DATACHART_VIEW_MACRO",
    KS_DATACHART_VIEW_MACRO: "KS_DATACHART_VIEW_MACRO",
    POPUP_SURVEY: "POPUP_SURVEY"
}
export default(TRACKING)